import { CompactRecentMatches } from "components/Matches/Compact/CompactRecentMatches";
import { CompactUpcomingMatches } from "components/Matches/Compact/CompactUpcomingMatches";
import { Tournament } from "model/Tournament/Tournament";
import { Column, GrowColumn } from "pages/styles";
import { COMPACT_COL_WIDTH } from "theme";
import { EmptyGrowPanelText } from "styles/text";
import { FinalRankingsTable } from "components/ResultTable/FinalRankings/FinalRankingsTable";
import { Panel } from "components/Panel/Panel";
import { selectTourIdsFromTournamentId } from "selectors/Tour";
import { CompactTourList } from "components/Tours/Compact/CompactTourList";
import { RosterGrid } from "../../RosterGrid/RosterGrid";
import { getTournamentRosterIds } from "model/Tournament/TournamentTeams";
import { useAppSelector } from "app/hooks";

interface Props {
  tournament: Tournament;
}

export const TournamentOverviewTab = ({ tournament }: Props) => {
  const linkedTourIds = useAppSelector((state) =>
    selectTourIdsFromTournamentId(state, tournament.id)
  );
  return (
    <>
      <GrowColumn>
        {tournament.teams.rosters.length > 0 ? (
          <>
            <Panel header="Final Ranking">
              <FinalRankingsTable tournament={tournament} />
            </Panel>
            <RosterGrid
              rosterIds={getTournamentRosterIds(tournament.teams)}
              tournamentId={tournament.id}
            />
          </>
        ) : (
          <Panel>
            <EmptyGrowPanelText>
              No teams are currently linked to this tournament
            </EmptyGrowPanelText>
          </Panel>
        )}
      </GrowColumn>
      <Column
        style={{ minWidth: COMPACT_COL_WIDTH, maxWidth: COMPACT_COL_WIDTH }}
        hideUnderWidth={1100}
      >
        {linkedTourIds.length > 0 && (
          <Panel header="Tours">
            <CompactTourList
              tourIds={linkedTourIds}
              hoverColor={tournament.theme?.secondary}
            />
          </Panel>
        )}
        <Panel header="Recent Matches">
          <CompactRecentMatches
            amount={4}
            tournamentIds={[tournament.id]}
            hoverColor={tournament.theme?.secondary}
          />
        </Panel>
        <Panel header="Upcoming Matches">
          <CompactUpcomingMatches
            amount={4}
            tournamentIds={[tournament.id]}
            hoverColor={tournament.theme?.secondary}
          />
        </Panel>
      </Column>
    </>
  );
};
